import { currencyNames } from '~/config/constant'
import { getInfoRestaurant } from './getInfoRestaurant'

// Lấy ra VAT với ngôn ngữ nhật khi tiền tệ là JPY và là ngôn ngữ nhật
export const getTextVat = (selectLanguage) => {
  const { currency } = getInfoRestaurant()
  if (currency === currencyNames.JPY && selectLanguage === 'ja') {
    return 'label.vat_ja'
  }
  return 'label.vat'
}

export const getTextExcludesVat = (selectLanguage) => {
  const { currency } = getInfoRestaurant()
  if (currency === currencyNames.JPY && selectLanguage === 'ja') {
    return 'titles.menu_excludes_vat_ja'
  }
  return 'titles.menu_excludes_vat'
}
